import React, { useContext, useEffect, useState } from "react";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import Illustration from "../assets/images/Illustration.svg";
import arrowRight from "../assets/images/arrow-right.svg";
import calendarIcon from "../assets/images/CalendarIcon.svg";
import uploadIcon from "../assets/images/UploadIcon.svg";
import { useNavigate } from "react-router-dom";
import { simpleGetCall, simplePostCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { AppContext } from "../contaxt/AppContext";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useRef } from "react";
import CustomButton from "../components/customButton";

const AdditionalInformation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const customDisbleStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: experience === "0" ? "#FAFAFA" : "",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,

    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };
  // const handleExperienceChange = (e) => {
  //   const { value } = e.target;
  //   if (Number(value) >= 0 && Number(value) <= 40) {
  //     setExperience(value);
  //   }
  // };

  const handleExperienceChange = (e) => {
    const { value } = e.target;
    const numericValue = Number(value);

    if (numericValue >= 0) {
      setExperience(value);
    }
  };

  const options = [
    {
      value: "High School",
      label: "High School",
    },
    {
      value: "Diploma",
      label: "Diploma",
    },
    {
      value: "PG Diploma",
      label: "PG Diploma",
    },
    {
      value: "Bachelor's",
      label: "Bachelor's",
    },
    { value: "Master's", label: "Master's" },
    { value: "PhD", label: "PhD" },
  ];
  const [selectedOption, setSelectedOption] = useState(null);

  const scrollHomeAdd = useRef(null);
  const scrollElementref = useRef(null);
  const scrollSalary = useRef(null);

  const handleScrollSalary = () => {
    setTimeout(() => {
      if (scrollSalary.current) {
        scrollSalary.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  useEffect(() => {
    if (scrollHomeAdd.current) {
      scrollHomeAdd.current.scrollIntoView({
        behavior: "smooth",
      });
    }
    setTimeout(() => {
      if (scrollElementref.current) {
        scrollElementref.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 2000);
  }, []);
  const { tokendatacontaxt, hide, sethide, userlgin, uniqueCode, setcodequerylgin } = useContext(AppContext);
  console.log(tokendatacontaxt);
  console.log(hide, "hide");
  const navigate = useNavigate();
  sethide(localStorage.getItem("Usertype") == "Employee");
  const [startDate, setStartDate] = useState(null);

  const [buyOutOption, setBuyOutOption] = useState(true); // State to manage selected option
  const [specializationdata, setSpecializationdata] = useState(""); // State to manage selected option
  const [spaciallistid, setSpaciallistID] = useState("");
  console.log(spaciallistid); // State to manage selected option
  const [spaciallist, setSpaciallist] = useState([]); // State to manage selected option
  const [getspacialdata, setGetSpacialData] = useState([]); // State to manage selected option
  const [addtionalInfoData, setAddtionalInforData] = useState([]); // State to manage selected option
  const [educationLevel, setEducationLevel] = useState("");
  const [fieldOfEducation, setFieldOfEducation] = useState("");
  const [experience, setExperience] = useState("");
  const [currentJobTitle, setCurrentJobTitle] = useState("");
  const [currentCompany, setCurrentCompany] = useState("");
  const [currentIndustry, setCurrentIndustry] = useState("");


  const getDateIn30Days = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + 30);
    return futureDate;
  };

  const resultDate = getDateIn30Days();
  console.log(resultDate);


  const [availableFrom, setAvailableFrom] = useState(getDateIn30Days());

  const [custom1, setCustom1] = useState("N/A");
  const [custom2, setCustom2] = useState("N/A");
  const [custom3, setCustom3] = useState("N/A");

  console.log(availableFrom, "availableFrom");
  const [noticePeriodBuyout, setNoticePeriodBuyout] = useState("");
  console.log("noticePeriodBuyout", noticePeriodBuyout);

  const [expectedSalary, setExpectedSalary] = useState("");
  const [uploadResume, setUploadResume] = useState("");
  const [uploadResumeSelected, setUploadResumeSelected] = useState(false);
  const [uploadResumeName, setUploadResumeName] = useState("");
  const [showorhidden, setshoworhidden] = useState(false);
  console.log(showorhidden, "showOrhidden");
  const [apiBlock, setApiBlock] = useState(false)
  const token = localStorage.getItem("authToken");
  console.log(token);
  const currentUserId = localStorage.getItem("customer_id");

  const salaryOptions = [
    { value: "Below 3 Lakhs per year", label: "Below 3 Lakhs per year" },
    { value: "3 to 5 Lakhs per year", label: "3 to 5 Lakhs per year" },
    { value: "5 to 7 Lakhs per year", label: "5 to 7 Lakhs per year" },
    { value: "7 to 9 Lakhs per year", label: "7 to 9 Lakhs per year" },
    { value: "9 to 12 Lakhs per year", label: "9 to 12 Lakhs per year" },
    { value: "12 to 15 Lakhs per year", label: "12 to 15 Lakhs per year" },
    { value: "15 to 18 Lakhs per year", label: "15 to 18 Lakhs per year" },
    { value: "18 to 22 Lakhs per year", label: "18 to 22 Lakhs per year" },
    { value: "22 to 26 Lakhs per year", label: "22 to 26 Lakhs per year" },
    { value: "26 to 30 Lakhs per year", label: "26 to 30 Lakhs per year" },
    { value: "30 to 35 Lakhs per year", label: "30 to 35 Lakhs per year" },
    { value: "35 to 40 Lakhs per year", label: "35 to 40 Lakhs per year" },
    { value: "40 to 45 Lakhs per year", label: "40 to 45 Lakhs per year" },
    { value: "45 to 50 Lakhs per year", label: "45 to 50 Lakhs per year" },
    { value: "50 to 60 Lakhs per year", label: "50 to 60 Lakhs per year" },
    { value: "60 to 70 Lakhs per year", label: "60 to 70 Lakhs per year" },
    { value: "70 to 80 Lakhs per year", label: "70 to 80 Lakhs per year" },
    { value: "80 Lakhs to 1 Cr per year", label: "80 Lakhs to 1 Cr per year" },
    { value: "Above 1 Cr per year", label: "Above 1 Cr per year" },
  ];


  const initialValidataion = {
    educationValidation: "",
    fieldValidation: "",
    experienceValidation: "",
    jobTitleValidation: "",
    currentCompanyValidation: "",
    currentIndustryValidation: "",
    dateValidation: "",
    expectedSalValidation: "",
    uploadResumeErr: "",
  };

  const [validation, setValidation] = useState(initialValidataion);

  const handleFileChanges = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      // reader.onloadend = () => {
      //   const arrayBuffer = reader.result;
      //   // Convert ArrayBuffer to binary string if needed
      //   // You can send the arrayBuffer directly to the server as binary data
      //   console.log(arrayBuffer);

      //   // Example: sending the arrayBuffer with fetch
      //   // fetch('your-server-endpoint', {
      //   //   method: 'POST',
      //   //   body: arrayBuffer,
      //   //   headers: {
      //   //     'Content-Type': 'application/pdf', // Change according to the file type
      //   //   },
      //   // })
      //     .then(response => response.json())
      //     .then(data => console.log(data))
      //     .catch(error => console.error('Error:', error));
      // };
      reader.readAsArrayBuffer(file);

      console.log(file.name, "file.name");
      setUploadResume(file.name);
    }
  };
  const handleOptionChange = (isYes) => {
    setBuyOutOption(isYes);
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const fileSizeMB = file.size / (1024 * 1024); // size in MB
  //     if (fileSizeMB > 25) {
  //       alert("File size exceeds 25MB. Please upload a smaller file.");
  //       e.target.value = ""; // reset the file input
  //     } else {
  //       document.getElementById("UploadResumeInput").value = file.name;
  //     }
  //   }
  // };

  const handleFileChange = (e) => {
    // alert("File changed");
    const file = e.target.files[0];

    if (file) {
      const fileSizeMB = file.size / (1024 * 1024); // Calculate file size in MB
      if (fileSizeMB > 25) {
        alert("File size exceeds 25MB. Please upload a smaller file.");
        e.target.value = ""; // Reset the file input by clearing its value
      } else {
        // Update the visible input field with the file name
        const uploadResumeInput = document.getElementById("UploadResumeInput");
        // alert("UploadResumeInput",uploadResumeInput);
        console.log(uploadResumeInput, "uploadResumeInput");
        if (uploadResumeInput) {
          // uploadResumeInput.value = file.name;
          // const reader = new FileReader();
          // reader.readAsArrayBuffer(file);
          // const arrayBuffer = reader.result;
          // console.log(arrayBuffer,'arrayBuffer');
          console.log(file, "file");
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            // var base64String = reader.result.split(',')[1];
            var base64String = reader.result;
            console.log(base64String, "base64String");
            setUploadResume(base64String);
            setUploadResumeSelected(true);
            setUploadResumeName(file.name);
          };
          reader.onerror = function (error) {
            console.log("Error: ", error);
          };
        }
      }
    }
  };

  useEffect(() => {
    let addinfoone = localStorage.getItem("addInfoOne");
    let addinfotwo = localStorage.getItem("addInfoTwo");
    if (addinfoone?.toLowerCase() == "yes") {
      setshoworhidden(true);
    } else {
      setshoworhidden(false);
    }
  });

  useEffect(() => {
    GetSpecializations();
    GetSpecializationData();
    getCustomQuestions();
    GetIndustryList();

    if (tokendatacontaxt === "" || tokendatacontaxt === null) {
    } else {
      GetSpecializations();
      GetSpecializationData();
      getCustomQuestions();
      GetIndustryList();
    }
  }, [tokendatacontaxt]);


  const [currentInd, setCurrentInd] = useState([]);
  const GetIndustryList = () => {
    simpleGetCall(ApiConfig.GET_INDUSTRY_LIST)
      .then(res => {
        console.log(res.response);

        if (res.response) {
          const options = [];
          res?.response?.forEach((item) => {
            options.push({
              value: item?.label,
              label: item?.label,
            })
          })
          setCurrentInd(options);
        }
      }).catch(err => console.log(err)
      )
  }
  // const handlechangeind=(e)=>{
  //   console.log(e.label);
  //   setCurrentIndLabel(e.value);

  // }
  const GetSpecializations = () => {
    let token = localStorage.getItem("authToken");
    let currentUserId = localStorage.getItem("customer_id");
    simpleGetCall(
      `${ApiConfig.GET_SPECIALIZATIONS}?currentUserId=${currentUserId}&token=${token}`
    )
      // simpleGetCall(ApiConfig.GET_SPECIALIZATIONS)
      .then((res) => {
        if (res.response) {
          const options = [];

          res?.response?.forEach((item) => {
            options.push({
              value: item?.specializationId,
              label: item?.specializationName,
            });
          });

          console.log(options, "2222222222222222222222222222222222222");

          setSpaciallist(options);

          // setLoading(false);
          // Extract the array of items from the response
          // Set the array to the state
        } else {
          // notifyError(res.message)
          // Handle the case when the result is false
          // notifyError(res.message);
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const [customs, setCustoms] = useState({
    customQue1: "",
    customQue2: "",
    customQue3: "",
  });
  const getCustomQuestions = () => {
    const code = localStorage.getItem("Uniquecode");
    simpleGetCall(`${ApiConfig.GET_CUSTOM_QUESTIONS}?jobcode=${uniqueCode}`)
      .then((res) => {
        if (res.succeded) {
          setCustoms({
            customQue1: res?.response?.question1,
            customQue2: res?.response?.question2,
            customQue3: res?.response?.question3,
          });
        } else {
          setCustoms({
            customQue1: "",
            customQue2: "",
            customQue3: "",
          });
        }
      })
      .catch((res) => console.log(res));
  };

  const submitAddtionalInfor = () => {
    const code = localStorage.getItem("Uniquecode");
    let isValidated = true;


    if (apiBlock) return

    let fieldValidation = "";
    let educationLevelValidation = "";
    let exprienceValidation = "";
    let jobTitleValidation = "";
    let currentCompanyValidation = "";
    let currentIndustryValidation = "";
    let dateValidation = "";
    let expectedSal = "";
    let uploadResumeErr = "";

    if (educationLevel?.length === 0) {
      educationLevelValidation = "Please Select Education";

      isValidated = false;
    } else {
      educationLevelValidation = "";
    }

    if (spaciallist?.length === 0) {
      fieldValidation = "Please Select Field";

      isValidated = false;
    } else {
      fieldValidation = "";
    }

    if (experience.length === 0) {
      exprienceValidation = "Please Enter Experience";

      isValidated = false;
    } else {
      exprienceValidation = "";
    }

    if (currentJobTitle.length === 0) {
      jobTitleValidation = "Please Enter Job Title";

      isValidated = false;
    } else {
      jobTitleValidation = "";
    }

    if (showorhidden) {
      if (uploadResumeName.length === 0) {
        uploadResumeErr = "please Select Resume";
        isValidated = false;
      }

      if (currentCompany.length === 0) {
        currentCompanyValidation = "Please Enter Company Name";

        isValidated = false;
      } else {
        currentCompanyValidation = "";
      }

      if (currentIndustry.length === 0) {
        currentIndustryValidation = "Please Select Current Industry";

        isValidated = false;
      } else {
        currentIndustryValidation = "";
      }
      if (!availableFrom) {
        dateValidation = "Please select today or a future date";
        isValidated = false;
      } else {
        dateValidation = "";
        isValidated = true;
      }

      // const today = new Date();

      // if (!availableFrom) {
      //   dateValidation = "Please Select Date";
      //   isValidated = false;
      // } else {
      //   const selectedDate = new Date(availableFrom);

      //   if (selectedDate < today) {
      //     dateValidation = "Please select today or a future date";
      //     isValidated = false;
      //   } else {
      //     dateValidation = "";
      //   }
      // }

      if (expectedSalary?.length === 0) {
        isValidated = false;

        expectedSal = "Please Add Expected Salary";
      } else {
        expectedSal = "";
      }
      if (uploadResume.length === 0) {
        isValidated = false;
      }
    }

    setValidation((prev) => ({
      ...prev,
      educationValidation: educationLevelValidation,
      fieldValidation: fieldValidation,
      experienceValidation: exprienceValidation,
      jobTitleValidation: jobTitleValidation,
      currentCompanyValidation: currentCompanyValidation,
      currentIndustryValidation: currentIndustryValidation,
      dateValidation: dateValidation,
      expectedSalValidation: expectedSal,
      uploadResumeErr: uploadResumeErr,
    }));

    const currentUserId = parseInt(localStorage.getItem("customer_id"));

    if (isValidated) {
      console.log(currentUserId, "upload");
      let requestData;

      setApiBlock(true)

      requestData = {
        userId: currentUserId, // Assuming this is a constant value
        educationlevel: educationLevel,
        fieldOfEducation: spaciallistid,
        experinces: experience,
        currentJobTittle: experience === "0" ? "No Work Experience" : currentJobTitle,
        currentCompany: experience === "0" ? "No Work Experience" : currentCompany,
        currentIndustry: experience === "0" ? "No Work Experience" : currentIndustry,
        availableFrom: availableFrom,
        noticePeriodbuyoptions: buyOutOption, // Convert to boolean
        expectedSalary: expectedSalary,
        uploadResume: uploadResumeSelected ? uploadResume : null,
        uploadResumeName: uploadResumeName,
        customQuestion1: custom1,
        customQuestion2: custom2,
        customQuestion3: custom3,
        code: code,
      };
      //  alert(requestData)
      //  console.log("request",requestData);
      //  return ;
      if (requestData) {
        simplePostCall(
          ApiConfig.SUBMIT_ADDITIONINFO,
          JSON.stringify(requestData)
        )
          .then((res) => {
            if (res.succeded) {
              if (userlgin) {
                navigate("/");
              } else {
                // navigate("/CompanyName");
                navigate("/CompanyName", { state: { showModal: true } });
              }
            } else {
              // Handle the case when the response is false or invalid
              setApiBlock(false)
              console.error("Error: No response or response is false");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            // setLoading(false);
          });
      }
    }
  };

  const GetSpecializationData = () => {
    let token = localStorage.getItem("authToken");
    const currentUserId = localStorage.getItem("customer_id");
    console.log(currentUserId);

    simpleGetCall(
      `${ApiConfig.GET_ADDITIONINFO}?UserId=${currentUserId}&token=${token}`
    )
      .then((res) => {
        console.log(res, "spacialdata");
        if (res.response) {
          if (res.response) {
            setGetSpacialData(res.response);
            populateFormFields(res.response);
          }
          console.log(res.response);
          setGetSpacialData(res.response);

          // setLoading(false);
          // Extract the array of items from the response
          // Set the array to the state
        } else {
          // notifyError(res.message)
          // Handle the case when the result is false
          // notifyError(res.message);
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      })
      .finally(() => {
        // setLoading(false);
      });
  };
  const populateFormFields = (data) => {
    console.log(data.educationlevel, "data populated");

    setEducationLevel(data.educationlevel || "");
    setSpaciallistID(data.specializationId || "");
    setExperience(data.experinces);
    setCurrentJobTitle(data.currentJobTittle || "");
    setCurrentCompany(data.currentCompany || "");
    setCurrentIndustry(data.currentIndustry || "");
    setCustom1(data.customQuestion1 || "");
    setCustom2(data.customQuestion2 || "");
    setCustom3(data.customQuestion3 || "");

    setUploadResume(data);
    if (data.availableFrom) {
      const date = new Date(data.availableFrom).toISOString();
      setAvailableFrom(date);
    } else {
      setAvailableFrom("");
    }
    // setAvailableFrom(data.availableFrom || '');
    setBuyOutOption(data.noticePeriodbuyoptions);
    setExpectedSalary(data.expectedSalary || "");
    // setUploadResume(data.uploadResume || '');
    setUploadResumeName(data.uploadResume || "");
  };

  return (
    <div className="aiWrap">
      <div className="clLft-side">
        <div className="clLogoStyleMob" ref={scrollHomeAdd}>
          <a href="/">
            <img src={LYWOLogoSmall} className="clLogoStyle" alt="Logo" />
          </a>
        </div>
        <div className="illustrationContainer">
          <img src={Illustration} className="illustImg" alt="Logo" />
        </div>
      </div>
      {showorhidden ? (
        <div className="row d-flex formSpc">
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-5 loginCode">
            <div className="text-center">
              <p>Additional information</p>
              <div className="addInfsubTxt" ref={scrollElementref}>
                <p>
                  Almost there! Please share some more information before we
                  take you to the test.
                </p>
              </div>
            </div>
            <div className="addInfrmtnArea">
              <div className="mb-3">
                <label htmlFor="EducationLevelInput">Education Level</label>
                <div
                  className={`input-group ${validation.educationValidation && educationLevel == ""
                    ? // ? "make-red-border"
                    ""
                    : ""
                    }`}
                >
                  <Select
                    styles={customStyles}
                    id="EducationLevelInput"
                    name="EducationLevelInput"
                    className={`form-selection scrollable-select`}
                    // value={educationLevel}
                    value={options.find(
                      (option) => option.value === educationLevel
                    )}
                    onChange={(selectedOption) =>
                      setEducationLevel(selectedOption.value)
                    }
                    options={options}
                  ></Select>
                </div>
                {/* <p
                  className={`${
                    validation.educationValidation && educationLevel == ""
                      ? "instructionTxtError"
                      : "d-none instructionTxt"
                  }`}
                >
                  {validation?.educationValidation}
                </p> */}
              </div>
              {/* <div className="mb-3">
                <label htmlFor="EducationLevelInput">Education Level</label>
                <div className="input-group">
                  <select
                    id="EducationLevelInput"
                    name="EducationLevelInput"
                    className={`form-select scrollable-select ${
                      validation.educationValidation && !educationLevel
                        ? "border-danger"
                        : ""
                    }`}
                    value={educationLevel}
                    onChange={(e) => setEducationLevel(e.target.value)}
                  >
                    <option value="" disabled selected>
                      Select Education Level
                    </option>
                    <option value="Bachelor of Engineering (B.E.)">
                      Bachelor of Engineering (B.E.)
                    </option>
                    <option value="Bachelor of Technology(B.Tech.)">
                      Bachelor of Technology(B.Tech.)
                    </option>
                    <option value="Master of Engineering (M.E)">
                      Master of Engineering (M.E)
                    </option>
                    <option value="Master of Technology(M.Tech)">
                      Master of Technology(M.Tech)
                    </option>
                    <option value="Diploma">Diploma</option>
                    <option value="Doctor">Doctor</option>
                    <option value="Post Graduate Diploma in Management (PGDM)">
                      Post Graduate Diploma in Management (PGDM)
                    </option>
                    <option value="⁠Chartered Accountancy (CA)">
                      ⁠Chartered Accountancy (CA)
                    </option>
                    <option value="⁠Company Secretary (CS)">
                      ⁠Company Secretary (CS)
                    </option>
                    <option value="⁠Integrated Bachelor of Laws (B.A. LLB, B.B.A. LLB, etc.)">
                      ⁠Integrated Bachelor of Laws (B.A. LLB, B.B.A. LLB, etc.)
                    </option>

                  </select>
                </div>
                <p
                  className={`${
                    validation.educationValidation && !educationLevel
                      ? "instructionTxtError"
                      : "instructionTxt"
                  }`}
                >
                  {validation?.educationValidation}
                </p>
              </div> */}

              <div className="mb-3">
                <label htmlFor="FieldOfEducationInput">
                  Field of Education
                </label>
                <div className="input-group">
                  <Select
                    // components={{
                    //   Input: (props) => (
                    //     <input {...props} className="customInput" />
                    //   ),
                    // }}
                    placeholder="Select an option"
                    value={spaciallist?.filter((i) => i.value == spaciallistid)}
                    id="FieldOfEducationInput"
                    name="FieldOfEducationInput"
                    className="form-selection basic-single "
                    options={spaciallist}
                    styles={customStyles}
                    classNamePrefix="select"
                    onChange={(e) => setSpaciallistID(e.value)}
                    isSearchable={true}
                  />
                </div>
                <p
                  className={`${validation.fieldValidation && !spaciallistid
                    ? "instructionTxtError"
                    : "d-none"
                    }`}
                >
                  Please Select Field Of Education
                </p>
              </div>
              {/* <div className="mb-3">
              <label htmlFor="FieldOfEducationInput">Field of Education</label>
              <div className="input-group">
                <select
                  id="FieldOfEducationInput"
                  name="FieldOfEducationInput"
                  className="form-select"
                  value={spaciallistid}
                  onChange={(e) => setSpaciallistID(e.target.value)}
                >
                  <option value="" disabled selected>
                    Select Field of Education
                  </option>
                  {spaciallist.map((item) => (
                  <option  value={item.specializationId } selected>
                     {item.specializationName}
                  </option>
                   
                ))}
                </select>
              </div>
              <p className="instructionTxt">{validation?.fieldValidation}</p>
            </div> */}
              {/* <div className="mb-3">
              <label htmlFor="ExperienceInput">Experience (in years)</label>
              <div className="input-group">
                <select
                  id="ExperienceInput"
                  name="ExperienceInput"
                  className="form-select"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                >
                  <option value="" disabled selected>
                    Select Experience
                  </option>
                  <option value="1">Experience @1</option>
                  <option value="2">Experience @2</option>
                  <option value="3">Experience @3</option>
                </select>
              </div>
            </div> */}
              <div className="mb-3">
                <label htmlFor="ExperienceInput">Experience (in years)</label>
                <div className="input-group">
                  <input
                    type="text"
                    id="ExperienceInput"
                    name="ExperienceInput"
                    className={`form-control ${validation.experienceValidation && !experience.length > 0
                      ? "border-danger"
                      : ""
                      }`}
                    value={experience > 40 ? "40+" : experience}
                    // onChange={(e) => setExperience(e.target.value)}
                    onChange={handleExperienceChange}
                    placeholder="Enter your experience"
                    min="0"
                  />
                </div>
                <p
                  className={`${validation.experienceValidation && !experience.length > 0
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation?.experienceValidation}
                </p>
              </div>
              <div className="mb-3">
                <label htmlFor="CurrentJobTitleInput">Current Job Title</label>
                <div className="input-group">
                  <input
                    type="text"
                    id="CurrentJobTitleInput"
                    name="CurrentJobTitleInput"
                    placeholder="Current Job Title"
                    value={experience === "0" ? "No Work Experience" : currentJobTitle}
                    disabled={experience === "0"}
                    // value={currentJobTitle}
                    className={`${validation.jobTitleValidation &&
                      !currentJobTitle.length > 0
                      ? "border-danger"
                      : ""
                      }`}
                    onChange={(e) => setCurrentJobTitle(e.target.value)}
                  />
                </div>
                <p
                  className={`${validation.jobTitleValidation && !currentJobTitle.length > 0
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation?.jobTitleValidation}
                </p>
              </div>
              <div className="mb-3">
                <label htmlFor="CurrentCompanyInput">Current Company</label>
                <div className="input-group">
                  <input
                    type="text"
                    id="CurrentCompanyInput"
                    name="CurrentCompanyInput"
                    className={`${validation.currentCompanyValidation &&
                      !currentCompany.length > 0
                      ? "border-danger"
                      : ""
                      }`}
                    placeholder="Current Company"
                    // value={currentCompany}
                    value={experience === "0" ? "No Work Experience" : currentCompany}
                    disabled={experience === "0"}
                    onChange={(e) => setCurrentCompany(e.target.value)}
                  />
                </div>
                <p
                  className={`${validation.currentCompanyValidation &&
                    !currentCompany.length > 0
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation?.currentCompanyValidation}
                </p>
              </div>
              <div className="mb-3">
                <label htmlFor="CurrentIndustryInput">Current Industry</label>
                <div
                  className={`input-group ${validation.currentIndustryValidation &&
                    currentIndustry == ""
                    ? "make-red-border"
                    : ""
                    }`}
                >
                  <Select
                    id="CurrentIndustryInput"
                    styles={customDisbleStyles}
                    name="CurrentIndustryInput"
                    className={` form-selection `}
                    // value={currentInd.filter(
                    //   (i) => i.value === currentIndustry
                    // )}
                    value={experience === "0"
                      ? { value: "No Work Experience", label: "No Work Experience" }
                      : currentInd.filter((i) => i.value === currentIndustry)
                    }
                    options={currentInd}
                    onChange={(selectedOption) => {
                      setCurrentIndustry(selectedOption.value);
                    }}
                  ></Select>
                </div>
                <p
                  className={`${validation.currentIndustryValidation &&
                    currentIndustry === ""
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation?.currentIndustryValidation}
                </p>
              </div>
              <div className="mb-3">
                <label htmlFor="ExpectedSalaryInput">Expected Salary</label>
                <div
                  onClick={handleScrollSalary}
                  ref={scrollSalary}
                  className={`input-group ${validation.expectedSalValidation && expectedSalary === ""
                    ? "make-red-border"
                    : ""
                    }`}
                >
                  <Select
                    styles={customStyles}
                    id="ExpectedSalaryInput"
                    name="ExpectedSalaryInput"
                    className="form-selection"
                    isSearchable={false}
                    value={salaryOptions?.filter(
                      (i) => i.value == expectedSalary
                    )}
                    options={salaryOptions}
                    onChange={(e) => setExpectedSalary(e.value)}
                  ></Select>
                </div>
                <p
                  className={`${validation.expectedSalValidation && expectedSalary === ""
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation?.expectedSalValidation}
                </p>
              </div>
              <div className="mb-3">
                <label htmlFor="AvailableFromInput">Available From</label>
                <div className="date-picker-container">
                  <DatePicker
                    placeholderText="DD/MM/YYYY"
                    selected={availableFrom}
                    onChange={(date) => setAvailableFrom(date)}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date()}
                    open={false}
                    className={`${validation.dateValidation ? "border-danger" : ""
                      }`}
                  />
                </div>
                <p
                  className={`${validation.dateValidation
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation.dateValidation}
                </p>
              </div>
              <div className="mb-3 yesno">
                <label htmlFor="YesOrNoInput">Buy Out Option Available?</label>
                <div className="input-groupp mt-2">
                  <div className="d-flex">
                    <input
                      type="radio"
                      id="buyOutOptionYes"
                      name="buyOutOption"
                      className="yesnoinput"
                      value={buyOutOption}
                      checked={buyOutOption}
                      onClick={() => handleOptionChange(true)}
                    />
                    <label
                      htmlFor="buyOutOptionYes"
                      className="ms-2 yesnolabel"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="d-flex ms-5">
                    <input
                      type="radio"
                      id="buyOutOptionNo"
                      name="buyOutOption"
                      className="yesnoinput"
                      value={!buyOutOption}
                      checked={!buyOutOption}
                      onClick={() => handleOptionChange(false)}
                    />
                    <label htmlFor="buyOutOptionNo" className="ms-2 yesnolabel">
                      No
                    </label>
                  </div>
                </div>
              </div>

              {customs.customQue1 !== "" && customs.customQue1 !== "N/A" && (
                <div className="mb-3 yesno">
                  <label htmlFor="customQuestion">{customs.customQue1}</label>
                  <div className="input-groupp mt-2">
                    <div className="d-flex">
                      <input
                        type="radio"
                        id="customQuesOneYes"
                        name="customQueOne"
                        className="yesnoinput"
                        value="Yes"
                        checked={custom1 === "Yes"}
                        onChange={() => setCustom1("Yes")}
                      />
                      <label htmlFor="customQuesOneYes" className="ms-2 yesnolabel">
                        Yes
                      </label>
                    </div>
                    <div className="d-flex ms-5">
                      <input
                        type="radio"
                        id="customQuesOneNo"
                        name="customQueOne"
                        className="yesnoinput"
                        value="No"
                        checked={custom1 === "No"}
                        onChange={() => setCustom1("No")}
                      />
                      <label htmlFor="customQuesOneNo" className="ms-2 yesnolabel">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {customs.customQue2 !== "" && customs.customQue2 !== "N/A" &&
                <div className="mb-3 yesno">
                  <label htmlFor="customQuestion">{customs.customQue2}</label>
                  <div className="input-groupp mt-2">
                    <div className="d-flex">
                      <input
                        type="radio"
                        id="customQuesTwoYes"
                        name="customQueTwo"
                        className="yesnoinput"
                        value="Yes"
                        checked={custom2 === "Yes"}
                        onChange={() => setCustom2("Yes")}
                      />
                      <label htmlFor="customQuesTwoYes" className="ms-2 yesnolabel">
                        Yes
                      </label>
                    </div>
                    <div className="d-flex ms-5">
                      <input
                        type="radio"
                        id="customQuesTwoNo"
                        name="customQueTwo"
                        className="yesnoinput"
                        value="No"
                        checked={custom2 === "No"}
                        onChange={() => setCustom2("No")}
                      />
                      <label htmlFor="customQuesTwoNo" className="ms-2 yesnolabel">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              }

              {
                customs.customQue3 !== "" && customs.customQue3 !== "N/A" &&
                <div className="mb-3 yesno">
                  <label htmlFor="customQuestion">{customs.customQue3}</label>
                  <div className="input-groupp mt-2">
                    <div className="d-flex">
                      <input
                        type="radio"
                        id="customQuesThreeYes"
                        name="customQueThree"
                        className="yesnoinput"
                        value="Yes"
                        checked={custom3 === "Yes"}
                        onChange={() => setCustom3("Yes")}
                      />
                      <label htmlFor="customQuesThreeYes" className="ms-2 yesnolabel">
                        Yes
                      </label>
                    </div>
                    <div className="d-flex ms-5">
                      <input
                        type="radio"
                        id="customQuesThreeNo"
                        name="customQueThree"
                        className="yesnoinput"
                        value="No"
                        checked={custom3 === "No"}
                        onChange={() => setCustom3("No")}
                      />
                      <label htmlFor="customQuesThreeNo" className="ms-2 yesnolabel">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              }

              <div className="mb-3">
                <label htmlFor="UploadResumeInput">Upload Resume</label>
                <div className="input-group">
                  <input //
                    readOnly
                    type="text"
                    id="UploadResumeInput"
                    className={`${validation.uploadResumeErr && uploadResumeName === ""
                      ? "border-danger"
                      : ""
                      }`}
                    name="UploadResumeInput"
                    placeholder="Upload Resume"
                    style={{ cursor: "pointer" }}
                    value={uploadResumeName}
                    onChange={(e) => {
                      setUploadResume(e.target.value);
                      setUploadResumeSelected(true);
                    }}
                    onClick={() =>
                      document.getElementById("hiddenFileInput").click()
                    }
                  />
                  <img
                    src={uploadIcon}
                    className="uploadIconStyl"
                    alt="Upload Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      document.getElementById("hiddenFileInput").click()
                    }
                  />
                  <input
                    type="file"
                    id="hiddenFileInput"
                    style={{ display: "none" }}
                    accept=".pdf, .doc, .docx"
                    onChange={handleFileChange}
                  />
                </div>
                <p
                  className={`instructionTxt ${validation.uploadResumeErr && uploadResumeName === ""
                    ? "text-danger"
                    : ""
                    } `}
                >
                  Upload your resume as a PDF or Word file, no larger than
                  25MBs.
                </p>
              </div>
            </div>
            <div className="btnArea">
              <CustomButton
                title="Proceed To Test"
                isIcon={true}
                src={arrowRight}
                isLoading={apiBlock}
                handleClick={submitAddtionalInfor}

              />
              {/* <button
                className="btnVldt"
                // onClick={() => navigate("/CompanyName")}
                onClick={() => submitAddtionalInfor()}
              >
                <p>Proceed to Test</p>
                <img
                  src={arrowRight}
                  className="arrowIconStyl"
                  alt="ArrowRight-Icon"
                />
              </button> */}
            </div>
          </div>
        </div>
      ) : (
        <div className="row d-flex formSpc">
          <div className="col-auto loginCode">
            <div className="text-center">
              <p>Additional information</p>
              <div className="addInfsubTxt">
                <p>
                  Almost there! Please share some more information before we
                  take you to the test.
                </p>
              </div>
            </div>
            <div className="addInfrmtnArea" ref={scrollElementref}>
              <div className="mb-3">
                <label htmlFor="EducationLevelInput">Education Level</label>
                <div
                  className={`input-group ${validation.educationValidation && educationLevel == ""
                    ? // ? "make-red-border"
                    ""
                    : ""
                    }`}
                >
                  <Select
                    styles={customStyles}
                    id="EducationLevelInput"
                    name="EducationLevelInput"
                    className={`form-selection scrollable-select`}
                    // value={educationLevel}
                    value={options.find(
                      (option) => option.value === educationLevel
                    )}
                    onChange={(selectedOption) =>
                      setEducationLevel(selectedOption.value)
                    }
                    options={options}
                  ></Select>
                </div>
                {/* <p
                  className={`${
                    validation.educationValidation && educationLevel == ""
                      ? "instructionTxtError"
                      : "d-none instructionTxt"
                  }`}
                >
                  {validation?.educationValidation}
                </p> */}
              </div>
              {/* <div className="mb-3">
                <label htmlFor="EducationLevelInput">Education Level</label>
                <div
                  className={`input-group ${
                    validation.educationValidation && !educationLevel
                      ? "make-red-border"
                      : "border"
                  }`}
                >
                  <select
                    id="EducationLevelInput"
                    name="EducationLevelInput"
                    className="form-select scrollable-select"
                    value={educationLevel}
                    onChange={(e) => setEducationLevel(e.target.value)}
                  >
                    <option value="" disabled selected>
                      Select Education Level
                    </option>
                    <option value="Bachelor of Engineering (B.E.)">
                      Bachelor of Engineering (B.E.)
                    </option>
                    <option value="Bachelor of Technology(B.Tech.)">
                      Bachelor of Technology(B.Tech.)
                    </option>
                    <option value="Master of Engineering (M.E)">
                      Master of Engineering (M.E)
                    </option>
                    <option value="Master of Technology(M.Tech)">
                      Master of Technology(M.Tech)
                    </option>
                    <option value="Diploma">Diploma</option>
                    <option value="Doctor">Doctor</option>
                    <option value="Post Graduate Diploma in Management (PGDM)">
                      Post Graduate Diploma in Management (PGDM)
                    </option>
                    <option value="⁠Chartered Accountancy (CA)">
                      ⁠Chartered Accountancy (CA)
                    </option>
                    <option value="⁠Company Secretary (CS)">
                      ⁠Company Secretary (CS)
                    </option>
                    <option value="⁠Integrated Bachelor of Laws (B.A. LLB, B.B.A. LLB, etc.)">
                      ⁠Integrated Bachelor of Laws (B.A. LLB, B.B.A. LLB, etc.)
                    </option>
                   
                  </select>
                </div>
                <p
                  className={`${
                    validation.educationValidation && !educationLevel
                      ? "instructionTxtError"
                      : "instructionTxt"
                  }`}
                >
                  {validation?.educationValidation}
                </p>
              </div> */}
              {/* <div className="mb-3">
              <label htmlFor="FieldOfEducationInput">Field of Education</label>
              <div className="input-group">
                <select
                  id="FieldOfEducationInput"
                  name="FieldOfEducationInput"
                  className="form-select"
                  value={spaciallistid}
                  onChange={(e) => setSpaciallistID(e.target.value)}
                >
                  <option value="" disabled selected>
                    Select Field of Education
                  </option>
                  {spaciallist.map((item) => (
                  <option  value={item.specializationId } selected>
                     {item.specializationName}
                  </option>
                   
                ))}
                </select>
              </div>
              <p className="instructionTxt">{validation?.fieldValidation}</p>
            </div> */}
              <div className="mb-3 extrafield">
                <label htmlFor="FieldOfEducationInput">
                  Field of Education
                </label>
                <div
                  className={`input-group ${validation.fieldValidation && !spaciallistid
                    ? "make-red-border"
                    : ""
                    }`}
                >
                  <Select
                    // components={{
                    //   Input: (props) => (
                    //     <input {...props} className="customInput" />
                    //   ),
                    // }}
                    placeholder="Select and option"
                    value={spaciallist.filter((i) => i.value == spaciallistid)}
                    className={`form-selection basic-single `}
                    options={spaciallist}
                    styles={customStyles}
                    classNamePrefix="select"
                    onChange={(e) => setSpaciallistID(e.value)}
                    isSearchable={true}
                  />
                </div>
                <p
                  className={`${validation.fieldValidation && !spaciallistid
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  Please Select Field Of Education
                </p>
              </div>
              {/* <div className="mb-3">
              <label htmlFor="ExperienceInput">Experience (in years)</label>
              <div className="input-group">
                <select
                  id="ExperienceInput"
                  name="ExperienceInput"
                  className="form-select"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                >
                  <option value="" disabled selected>
                    Select Experience
                  </option>
                  <option value="1">Experience @1</option>
                  <option value="2">Experience @2</option>
                  <option value="3">Experience @3</option>
                </select>
              </div>
            </div> */}
              <div className="mb-3">
                <label htmlFor="ExperienceInput">Experience (in years)</label>
                <div
                  className={`input-group ${validation.experienceValidation && !experience.length > 0
                    ? "make-red-border"
                    : ""
                    } `}
                >
                  <input
                    type="text"
                    id="ExperienceInput"
                    name="ExperienceInput"
                    className="form-control"
                    value={experience > 40 ? "40+" : experience}
                    // onChange={(e) => setExperience(e.target.value)}
                    onChange={handleExperienceChange}
                    placeholder="Enter your experience"
                    min="0"
                  />
                </div>
                <p
                  className={`${validation.experienceValidation && !experience.length > 0
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation?.experienceValidation}
                </p>
              </div>
              <div className="mb-3">
                <label htmlFor="CurrentJobTitleInput">Current Job Title</label>
                <div
                  className={`input-group ${validation.jobTitleValidation && !currentJobTitle.length > 0
                    ? "make-red-border"
                    : ""
                    }`}
                >
                  <input
                    type="text"
                    id="CurrentJobTitleInput"
                    name="CurrentJobTitleInput"
                    placeholder="Current Job Title"
                    // value={currentJobTitle}
                    value={experience === "0" ? "No Work Experience" : currentJobTitle}
                    onChange={(e) => setCurrentJobTitle(e.target.value)}
                  />
                </div>
                <p
                  className={`${validation.jobTitleValidation && !currentJobTitle.length > 0
                    ? "instructionTxtError"
                    : "instructionTxt"
                    }`}
                >
                  {validation?.jobTitleValidation}
                </p>
              </div>
              {/* <div className="mb-3">
              <label htmlFor="CurrentCompanyInput">Current Company</label>
              <div className="input-group">
                <input
                  type="text"
                  id="CurrentCompanyInput"
                  name="CurrentCompanyInput"
                  placeholder="Current Company"
                  value={currentCompany}
                  onChange={(e)=>setCurrentCompany(e.target.value)}
                />
              </div>
            </div> */}
              {/* <div className="mb-3">
              <label htmlFor="CurrentIndustryInput">Current Industry</label>
              <div className="input-group">
                <select
                  id="CurrentIndustryInput"
                  name="CurrentIndustryInput"
                  className="form-select"
                  value={currentIndustry}
                  onChange={(e)=>setCurrentIndustry(e.target.value)}
                >
                  <option value="" disabled selected>
                    Current Industry
                  </option>
                  <option value="industry @1">Industry @1</option>
                  <option value="industry @2">Industry @2</option>
                  <option value="industry @3">Industry @3</option>
                </select>
              </div>
            </div> */}
              {/* <div className="mb-3">
              <label htmlFor="AvailableFromInput">Available From</label>
              <div className="input-group">
                <input
                  type="date"
                  id="AvailableFromInput"
                  name="AvailableFromInput"
                  placeholder="Available From"
                  value={availableFrom}
                  onChange={(e)=>setAvailableFrom(e.target.value)}
                />
               
              </div>
            </div> */}
              {/* <div className="mb-3">
              <label htmlFor="YesOrNoInput">
                Notice Period Buy Out Option Available?
              </label>
              <div className="input-group mt-2">
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="buyOutOptionYes"
                    name="buyOutOption"
                    className="form-check-input"
                    value={true}
                    checked={buyOutOption === true}
                    onChange={handleOptionChange}
                  />
                  <label htmlFor="buyOutOptionYes" className="form-check-label">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="buyOutOptionNo"
                    name="buyOutOption"
                    className="form-check-input"
                    value={buyOutOption}
                    checked={buyOutOption === "no"}
                    onChange={handleOptionChange}
                  />
                  <label htmlFor="buyOutOptionNo" className="form-check-label">
                    No
                  </label>
                </div>
              </div>
            </div> */}
              {/* <div className="mb-3">
              <label htmlFor="ExpectedSalaryInput">Expected Salary</label>
              <div className="input-group">
                <select
                  id="ExpectedSalaryInput"
                  name="ExpectedSalaryInput"
                  className="form-select"
                  value={expectedSalary}
                  onChange={(e)=>setExpectedSalary(e.target.value)}
                >
                  <option value="" disabled selected>
                    Expected Salary
                  </option>
                  <option value="₹100,000 - ₹200,000" selected>
                    ₹100,000 - ₹200,000
                  </option>
                  <option value="₹200,000 - ₹300,000">
                    ₹200,000 - ₹300,000
                  </option>
                  <option value="₹300,000 - ₹400,000">
                    ₹300,000 - ₹400,000
                  </option>
                </select>
              </div>
            </div> */}
              {/* <div className="mb-3">
              <label htmlFor="UploadResumeInput">Upload Resume</label>
              <div className="input-group">
                <input
                  readOnly
                  type="text"
                  id="UploadResumeInput"
                  name="UploadResumeInput"
                  placeholder="Upload Resume"
                  style={{ cursor: "pointer" }}
                  value={uploadResume}
                  onChange={(e)=>setUploadResume(e.target.value)}
                  onClick={() =>
                    document.getElementById("hiddenFileInput").click()
                  }
                />
                <img
                  src={uploadIcon}
                  className="uploadIconStyl"
                  alt="Upload Icon"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    document.getElementById("hiddenFileInput").click()
                  }
                />
                <input
                  type="file"
                  id="hiddenFileInput"
                  style={{ display: "none" }}
                  accept=".pdf, .doc, .docx"
                  onChange={handleFileChange}
                />
              </div>
              <p className="instructionTxt">
                Upload your resume as a PDF or Word file, no larger than 25MBs.
              </p>
            </div> */}
            </div>
            <div className="btnArea">
              <CustomButton
                title="Proceed To Test"
                isIcon={true}
                src={arrowRight}
                isLoading={apiBlock}
                handleClick={submitAddtionalInfor}

              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdditionalInformation;
